import { Hidden } from '@material-ui/core';
import React from 'react';
import { Group } from './groups-model';
import { SearchProps } from '../../models/arc-epi-props';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';

interface Props {
    group: Group;
    onSelect: (group: Group) => void;
    settings: SearchProps,
}
export function GroupItemView(props: Props) {
    const { group, onSelect } = props;
    const buttonClasses = buttonStyles();
    return (
        <div className='sort-table-row'>
            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.groupIDLabel}</p>
                </Hidden>
                <button className={buttonClasses.linkButton} type='button' onClick={() => onSelect(group)}>{group.group_id}</button>
            </div>
            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.groupNameLabel}</p>
                </Hidden>
                <div>{group.name}</div>
            </div>

        </div>

    );

}